import { ReactChild } from 'react';
import cn from 'classnames';

import styles from './InfoBlock.module.scss';

interface IInfoBlockProps {
  children: ReactChild;
  color?: 'default' | 'yellow' | 'red';
  iconVerticalPosition?: 'center' | 'top';
  marginBottom?: string;
  className?: string;
}

export const InfoBlock = ({
  children,
  color = 'default',
  iconVerticalPosition = 'center',
  marginBottom,
  className,
}: IInfoBlockProps) => {
  const classNames = cn([
    styles.InformationSupportBody,
    {
      [styles.YellowColor]: color === 'yellow',
      [styles.RedColor]: color === 'red',
      [styles.IconTopVerticalPosition]: iconVerticalPosition === 'top',
    },
    className,
  ]);

  return (
    <div className={classNames} style={{ marginBottom }}>
      <svg className={styles.InfoIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13 7V13H11V7H13ZM12 15.5C12.5523 15.5 13 15.9477 13 16.5V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V16.5C11 15.9477 11.4477 15.5 12 15.5Z"
          fill="currentColor"
        />
      </svg>
      <span className={styles.InformationSupportText}>{children}</span>
    </div>
  );
};
